import { Component } from 'react';
import { FormikProps } from 'formik';

import { PurchaseOrderDetailPositionsFormValues } from '../purchase-order-detail-positions';
import { isPurchaseOrderProductItem } from '../../../models/purchase-order-item';
import { withoutBlankPositions } from '../../../../../common/components/palo/palo-first-position';

interface DetailPositionsCtaHelperProps {
    formikProps: FormikProps<PurchaseOrderDetailPositionsFormValues>;
    onChange: (ctaButtonEnabled: boolean, ctaData: CtaButtonData) => void;
}

interface CtaButtonData {
    needsSave: boolean;
}

export class DetailPositionsCtaHelper extends Component<DetailPositionsCtaHelperProps> {
    public needsSave = true;
    public buttonEnabled = false;

    private submitChange = () => {
        if (this.props.onChange) {
            this.props.onChange(this.buttonEnabled, { needsSave: this.needsSave });
        }
    };

    private getNeedsSave = (props: DetailPositionsCtaHelperProps) => {
        const isDirty = props.formikProps.dirty;
        // The blank first row is never saved, so it does not wait for it (#2308).
        const allItemsSaved = withoutBlankPositions(
            props.formikProps.values.allItems,
            isPurchaseOrderProductItem
        ).every(item => item.id !== undefined);
        return isDirty || !allItemsSaved;
    };

    private getCtaButtonEnabled = (props: DetailPositionsCtaHelperProps) => {
        const itemCount = withoutBlankPositions(props.formikProps.values.allItems, isPurchaseOrderProductItem).length;
        return itemCount > 0;
    };

    public componentDidMount() {
        this.needsSave = this.getNeedsSave(this.props);
        this.buttonEnabled = this.getCtaButtonEnabled(this.props);
        this.submitChange();
    }

    public UNSAFE_componentWillReceiveProps(nextProps: DetailPositionsCtaHelperProps) {
        const needsSave = this.getNeedsSave(nextProps);
        const buttonEnabled = this.getCtaButtonEnabled(nextProps);
        if (this.needsSave !== needsSave || this.buttonEnabled !== buttonEnabled) {
            this.needsSave = needsSave;
            this.buttonEnabled = buttonEnabled;
            this.submitChange();
        }
    }

    public render() {
        return null;
    }
}
